export enum MachineGroupMenuItems{
  MACHINES = 'machines',
  USERS = 'users',
  GROUPS = 'groups',
  TRIGGER_ACTION = 'trigger-action',
  TRIGGER_CONFIGURATION = 'trigger-configuration',
}
